import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/modify',
    component: () => import('@/views/modify/modify'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '首页', icon: 'el-icon-s-home' }
    }]
  },
  {
    path: '/goldcoins',
    component: Layout,
    name: 'GoldCoins',
    children: [{
      path: 'goldcoins',
      name: 'GoldCoins',
      component: () => import('@/views/goldcoins/index'),
      meta: { title: '金币系统', icon: 'el-icon-s-finance' }
    }]
  },
  {
    path: '/usermanage',
    component: Layout,
    name: 'Usermanage',
    children: [{
      path: 'usermanage',
      name: 'Usermanage',
      component: () => import('@/views/usermanage/index'),
      meta: { title: '用户管理', icon: 'el-icon-s-custom' }
    },
    {
      path: 'audio',
      name: 'Audio',
      component: () => import('@/views/usermanage/audioList'),
      hidden: true,
      meta: { title: '用户回放' }
    }]
  },
  {
    path: '/courseware',
    component: Layout,
    name: 'Courseware',
    children: [{
      path: 'courseware',
      name: 'Courseware',
      component: () => import('@/views/courseware/index'),
      meta: { title: '课件管理', icon: 'el-icon-s-tools' }
    }]
  },
  {
    path: '/level',
    component: Layout,
    name: 'Level',
    children: [{
      path: 'level',
      name: 'Level',
      component: () => import('@/views/level/index'),
      meta: { title: '星级设置', icon: 'el-icon-s-tools' }
    }]
  },
  {
    path: '/system',
    component: Layout,
    name: 'System',
    meta: { title: '系统管理', icon: 'el-icon-s-tools' },
    children: [
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('@/views/system/admin'),
        meta: { title: '管理员管理' }
      },
      {
        path: 'power',
        name: 'Power',
        component: () => import('@/views/system/power'),
        meta: { title: '权限管理' }
      },
      {
        path: 'handleJournal',
        name: 'HandleJournal',
        component: () => import('@/views/system/handleJournal'),
        meta: { title: '操作日志' }
      },
      {
        path: 'loginJournal',
        name: 'LoginJournal',
        component: () => import('@/views/system/loginJournal'),
        meta: { title: '登录日志' }
      },
      {
        path: 'content',
        name: 'Content',
        component: () => import('@/views/system/content'),
        meta: { title: '文本管理' }
      }
    ]
  },
  {
    path: '/recharge',
    component: Layout,
    name: 'Recharge',
    meta: { title: '充值管理', icon: 'el-icon-s-tools' },
    children: [
      {
        path: 'setting',
        name: 'Setting',
        component: () => import('@/views/recharge/setting'),
        meta: { title: '充值设置' }
      },
      {
        path: 'record',
        name: 'Record',
        component: () => import('@/views/recharge/record'),
        meta: { title: '充值记录' }
      }
    ]
  },

  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
